// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
import { URL_API } from './../app/constante';
import { URL_CAS } from './../app/constante';
import { URL_LOGOUT } from './../app/constante';

export const environment = {
  production: false,
  url_api: URL_API,
  url_cas: URL_CAS,
  url_logout: URL_LOGOUT
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts